export { Tooltip } from "@mantine/core";
export type { TooltipProps } from "@mantine/core";
export { getTooltipOverrides } from "./Tooltip.styled";
